import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CountrySelectionService } from './country-selection.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PeriodTrackerService {

  constructor(private http: HttpClient, private countrySelectionService: CountrySelectionService) { }

  getPeriodTrackerContent(): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('get_period_tracker_content', country);
        return this.http.get<any[]>(apiUrl);
      })
    );
  }

  savePeriodCycle(data: any): Observable<any> {
    return this.countrySelectionService.selectedCountry$.pipe(
      switchMap(country => {
        const apiUrl = this.countrySelectionService.getApiUrl('period_tracker', country);
        return this.http.post(apiUrl, data);
      })
    );
  }
}
